require('./style.css');
var tmpl = require('./main.ejs');
var Events = require('f.core.event');
var util = require('f.core.mobile.util');

var Control = function (options) {
  this.options = options;
  this.isHide = false;
  this.init();
  this.hideTimer = null;
};

Control.prototype.init = function () {
  this.initDom();
  this.initEvent();
  this.initZoomState();
};

Control.prototype.initDom = function () {
  var div = document.createElement('div');
  var nowTime = Date.parse(new Date());
  if (this.options.start_date > nowTime) {
    // 直播未开始
    this.isLive = '0';
  } else if (nowTime > this.options.end_date) {
    // 直播已结束
    this.isLive = '2';
  } else {
    // 正在直播中
    this.isLive = '1';
  }
  div.innerHTML = tmpl({ isLive: this.isLive });
  this.el = div.children[0];
  this.elPlayBtn = this.el.querySelector('.c-livevideo-control__button');
  this.elZoom = this.el.querySelector('.c-livevideo-control__zoom');
};

Control.prototype.initEvent = function () {

  util.tap(this.elPlayBtn, function () {
    this.trigger('play');
    return false;
  }, {
    scope: this
  });

  util.tap(this.elZoom, function () {
    var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
    if (Math.abs(dge) == 90) {
      this.trigger('zoom', 'zoomin');
    } else {
      this.trigger('zoom', 'zoomout');
    }
    return false;
  }, {
    scope: this
  });

  // 为了在你触摸控制条的时候，控制条不消失。
  // util.swip(this.el, function () {
  //   clearTimeout(this.hideTimer);
  // }, function () {
  // }, function () {
  //   this.hideTimer = setTimeout(function () {
  //     this.hide();
  //   }.bind(this), 3000);
  // }, {
  //   scope: this
  // });

  util.tap(this.el, function () {
    return false;
  });
  util.on(window, 'orientationchange', function () {
    this.initZoomState();
    this.resize();
  }, {
    scope: this
  });
};

Control.prototype.initZoomState = function () {
    var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
  if (Math.abs(dge) == 90) {
    $(this.elZoom).removeClass('c-livevideo-control__zoom--zoomin')
                  .addClass('c-livevideo-control__zoom--zoomout')
  } else {
    $(this.elZoom).removeClass('c-livevideo-control__zoom--zoomout')
                  .addClass('c-livevideo-control__zoom--zoomin')
  }
};

Control.prototype.renderTo = function (parentNode) {
  parentNode.appendChild(this.el);
};

Control.prototype.show = function () {
  $(this.el).stop().animate({
    bottom: '0px'
  });
  // this.el.style.visibility = 'visible';
  this.trigger('show');
  this.isHide = false;
  clearTimeout(this.hideTimer);
  this.hideTimer = setTimeout(function () {
    this.hide();
  }.bind(this), 3000);
};

Control.prototype.hide = function () {
  $(this.el).stop().animate({
    bottom: '-200px'
  });
  // this.el.style.visibility = 'hidden';
  this.isHide = true;
  this.trigger('hide');
};

Control.prototype.toggle = function () {
  if (this.isHide == true) {
    this.show();
  } else {
    this.hide();
  }
};

Control.prototype.changePlayState = function (type) {
  var types = {
    'play': 'c-livevideo-control__button--pause',
    'pause': 'c-livevideo-control__button--play',
  };
  this.elPlayBtn.className = 'c-livevideo-control__button ' + types[type];
};

Control.prototype.changeFullState = function (type) {
  var types = {
    'zoomout': 'c-livevideo-control__zoom--zoomin',
    'zoomin': 'c-livevideo-control__zoom--zoomout',
  };
  this.elPlayBtn.className = 'c-livevideo-control__button ' + types[type];
};

Control.prototype.reset = function () {
  this.changePlayState('pause');
};

Control.prototype.resize = function () {
};

Control.prototype.destory = function () {
  this.off();
  this.el.parentNode.removeChild(this.el);
};

Events.mixTo(Control);

module.exports = Control;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/liveControl/index.js